import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Lock } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { useAuth } from '../../context/AuthContext';
import { ProviderToggle } from './ProviderToggle';
import { EvidenceAnalysis } from './EvidenceAnalysis';
import { CaseAssistant } from './CaseAssistant';
import { ReportDraft } from './ReportDraft';

const PAID = ['starter', 'professional', 'enterprise'];

const UpgradeNotice = () => (
  <div className="text-center py-10" data-testid="ai-upgrade-notice">
    <Lock className="w-10 h-10 text-purple-400 mx-auto mb-3" />
    <p className="text-gray-700 mb-4">AI analysis, the case assistant and report drafting are included in every paid plan.</p>
    <Link to="/pricing" data-testid="ai-upgrade-btn" className="inline-block bg-purple-600 text-white px-5 py-2 rounded-lg hover:bg-purple-700 transition-colors">See plans</Link>
  </div>
);

export const AiWorkspace = ({ caseId, evidences, onActivity }) => {
  const { user } = useAuth();
  const [provider, setProvider] = useState('openai');
  const allowed = user && (user.role === 'admin' || PAID.includes(user.subscription_tier));

  return (
    <section className="bg-white rounded-lg shadow p-6 mb-6" data-testid="ai-workspace">
      <div className="flex flex-wrap justify-between items-center gap-3 mb-4">
        <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2"><Sparkles className="w-5 h-5 text-purple-600" /> AI Workspace</h2>
        {allowed && <ProviderToggle value={provider} onChange={setProvider} />}
      </div>
      {!allowed ? <UpgradeNotice /> : (
        <Tabs defaultValue="analyze">
          <TabsList className="mb-4">
            <TabsTrigger value="analyze" data-testid="ai-tab-analyze">Analyze evidence</TabsTrigger>
            <TabsTrigger value="chat" data-testid="ai-tab-chat">Case assistant</TabsTrigger>
            <TabsTrigger value="report" data-testid="ai-tab-report">Report draft</TabsTrigger>
          </TabsList>
          <TabsContent value="analyze"><EvidenceAnalysis caseId={caseId} evidences={evidences} provider={provider} onDone={onActivity} /></TabsContent>
          <TabsContent value="chat"><CaseAssistant caseId={caseId} provider={provider} /></TabsContent>
          <TabsContent value="report"><ReportDraft caseId={caseId} provider={provider} onDone={onActivity} /></TabsContent>
        </Tabs>
      )}
    </section>
  );
};
